<div>
  <p-table
    data-test-id="documents-table"
    responsiveLayout="scroll"
    [alwaysShowPaginator]="false"
    [metaKeySelection]="false"
    [paginator]="true"
    [rows]="10"
    [value]="documents"
    [(selection)]="selected"
    (onRowSelect)="onRowToggle()"
    (onRowUnselect)="onRowToggle()"
  >
    <ng-template let-columns pTemplate="header">
      <tr>
        <th style="width: 4rem">Select</th>
        <th style="width: 15rem">File Name</th>
        <th style="width: 15rem">Document Type</th>
        <th style="width: 15rem">Comm. Type</th>
        <th style="width: 15rem">Provider Type</th>
        <th style="width: 10rem">Created On</th>
        <th style="width: 5rem">Created By</th>
        <th style="width: 5rem">&nbsp;</th>
      </tr>
    </ng-template>
    <ng-template let-rowData let-rowIndex="rowIndex" pTemplate="body">
      <tr [pSelectableRow]="rowData">
        <td style="width: 4rem">
          <!-- Don't show button if source is EHR && !documentStorageLocation, inverse shown here for simplicity  -->
          @if (rowData.documentSource !== 'EHR' || rowData.documentStorageLocation) {
            @if (!(isPacCommercial && rowData.documentSource === letter)) {
              <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            }
          }
        </td>
        <td>
          <span class="inline-flex w-full justify-start">
            <!-- Normal exclusion logic for preview and selection -->
            @if (
              (isPacCommercial && rowData.documentSource === letter) ||
              (rowData.documentSource === 'EHR' && !rowData.documentStorageLocation)
            ) {
              <p
                class="truncate px-0"
                pTooltip="{{ rowData.documentFileName }}"
                tooltipPosition="bottom"
              >
                {{ rowData.documentFileName }}
              </p>
            } @else {
              <button
                pButton
                class="p-button-link truncate px-0 inline-block"
                pTooltip="{{ rowData?.['documentFileName'] }}"
                tooltipPosition="bottom"
                [ngClass]="{ 'visited-table-link': documentPreviewed(rowIndex) }"
                (click)="preview($event, rowData, rowIndex)"
              >
                {{ rowData.documentFileName }}
              </button>
            }
          </span>
        </td>
        <td style="max-width: 15rem">
          <span class="truncate" tooltipStyleClass="tooltip-xl-size" [pTooltip]="rowData['documentType']">
            {{ rowData['documentType'] }}
          </span>
        </td>
        <!-- <td style="width: 12rem">{{ rowData['communicationType'] }}</td> -->
        <td style="width: 12rem">{{ rowData['documentSource'] }}</td>
        <td style="width: 12rem">{{ rowData['recipientType'] }}</td>
        <td style="width: 10rem">{{ rowData['createdOnDisplay'] | date: 'MM/dd/yyyy hh:mm:ss a' }}</td>
        <td style="width: 5rem">{{ rowData['createdBy'] }}</td>
        <td style="width: 5rem; height: 4rem">
          <!-- Don't show button if source is EHR && !documentStorageLocation, inverse shown here for simplicity  -->
          @if (rowData.documentSource !== 'EHR' || rowData.documentStorageLocation) {
            @if (!(isPacCommercial && rowData.documentSource === letter)) {
              <div class="inline-block m-0">
                <button
                  pButton
                  aria-label="Preview document"
                  class="p-button-text"
                  icon="pi pi-external-link"
                  label="Preview"
                  type="button"
                  [ngClass]="{'p-table-button-clicked': documentPreviewed(rowIndex)}"
                  (click)="preview($event, rowData, rowIndex)"
                >
                  <div class="pr-1">
                    @if (isLoading && rowIndex === selectedRowIndex) {
                      <i aria-hidden="true" class="pi pi-spin pi-spinner"></i>
                    }
                  </div>
                </button>
              </div>
            }
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
